import { Button, DatePicker, Form, Input, InputNumber, Modal, Radio, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FormWrapper, GoBackBtn, Header, Wrapper } from './styles';

import { DeleteOutlined, LeftOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import UploadImg from '../../../../components/uploadImage';
import { financeCategoryList } from '../../../../constants/finance';
import { useAddFinance, useCar, useDeleteFinance, useFinance, useFinances } from '../../../../zustand/store';
import { AddButton } from '../styles';
import { CarItem } from '../../../mainPage/carsPage';
// import { GoBackBtn } from '../../styles';


const DeleteSection = () => {
    const [open, setOpen] = useState(false);
    let { id: carId, eId: id } = useParams();
    const del = useDeleteFinance();
    const finances = useFinances();
    const navigate = useNavigate();


    const confirmDelete = () => {
        del.execute({
            params: { id, carId },
            onSuccess: () => {
                finances.execute({ params: { carId }, force: true });
                navigate(`/car/${carId}`);
            }
        });
    }

    return (
        <>
            <Button danger size='large' onClick={() => setOpen(true)} >
                {/* Delete */}
                <DeleteOutlined />
            </Button>
            <Modal
                onOk={confirmDelete}
                title="Delete" centered open={open} onCancel={() => setOpen(false)} okText="Delete" okButtonProps={{ danger: true }}>
                Do you really want to delete this?
            </Modal>
        </>
    )
}

const CarBox = ({ carId }) => {

    const car = useCar();

    useEffect(() => {
        car.execute({
            params: { id: carId }, force: true,
        })
    }, [carId])

    return !!car.data && <div style={{ width: "100%", display: "flex" }}>
        <CarItem  {...car.data} />
    </div>
}

function ExpenseForm() {
    // const { id } = useParams();
    // const navigate = useNavigate();
    // return (
    //     <Wrapper>
    //         <GoBackBtn onClick={() => {
    //             navigate(`/car/${id}`)
    //         }}>
    //             <LeftOutlined />
    //         </GoBackBtn>
    //         <Dropdown menu={{ items: [{ label: "Delete", key: "delete" }], onClick: () => { } }}>
    //             <MenuBtn>
    //                 <MenuOutlined />
    //             </MenuBtn>
    //         </Dropdown>
    //         <ImgWrapper>
    //             <img src={mechanic} alt="" />
    //             <UploadImgWrapper>
    //                 <CloudUploadOutlined />
    //                 <input type="file" />
    //             </UploadImgWrapper>
    //         </ImgWrapper>

    //         <DataWrapper>
    //             <div>
    //                 <PriceBox>
    //                     $200.00
    //                 </PriceBox>
    //                 <NameBox>
    //                     Repair battery
    //                 </NameBox>
    //                 <DateBox>09/02/2001</DateBox>
    //             </div>
    //             {/* <div>
    //                 <DeleteButton danger block>
    //                     Delete
    //                 </DeleteButton>
    //             </div> */}
    //         </DataWrapper>
    //     </Wrapper>
    // )
    const [imgList, setImgList] = useState([]);
    const [category, setCategory] = useState("Other");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    let { id: carId, eId: id } = useParams();
    const addFinance = useAddFinance();
    const finances = useFinances();
    const finance = useFinance();

    const [form] = Form.useForm();

    useEffect(() => {
        if (id) {
            finance.execute({
                params: { id }, force: true,
                onSuccess: (res) => {
                    const data = res.data;
                    setCategory(data.category);
                    form.setFieldsValue({
                        // category: data.category,
                        // make: data.make,
                        // model: data.model,
                        // color: data.color,
                        // year: dayjs(data.year),
                        // mileage: data.mileage,
                        price: data.price,
                        note: data.note,
                        addedAt: dayjs(data.addedAt)
                    })
                    setImgList(data.images)
                    // console.log(data);
                }
            });
        }
        const c = searchParams.get("c");
        if (c) {
            setCategory(c);
        }
    }, [])

    const from = searchParams.get("from");


    return (
        <Wrapper>
            <Header>
                <GoBackBtn onClick={() => {

                    if (from === "finance") {
                        navigate("/finance");
                    } else {
                        navigate(`/car/${carId}`);
                    }

                    // if (id) {
                    //     navigate(`/car/${carId}/expense/${id}`);
                    // } else {
                    // }
                }}>
                    <LeftOutlined />
                </GoBackBtn>
                <DeleteSection />
            </Header>

            {from === "finance" && <CarBox carId={carId} />}
            <UploadImg imgList={imgList} setImgList={setImgList} />
            <FormWrapper>
                <Form size='large' layout='vertical'
                    form={form}
                    onFinish={(e) => {
                        // e.year = e.year.year();
                        e.addedAt = (e.addedAt || dayjs());
                        // e.addedAt = e.addedAt.format("DD/MM/YYYY");
                        console.log(e);
                        e.images = imgList?.filter(({ photo }) => photo.length)?.map(({ photo, main }) => ({ photo, main }));
                        e.image = imgList?.find(({ main }) => main)?.photo;
                        e.carId = carId;
                        e.category = category;
                        e.type = e.type || (category === "Sold" ? "income" : "expense")
                        addFinance.execute({
                            data: e, params: { id },
                            onSuccess: () => {
                                navigate(`/car/${carId}`);
                                finances.execute({ params: { carId }, force: true });
                            }
                        })

                            ;
                        // (id ? editCar : addCar).execute({
                        //     params: { id },
                        //     data: e, onSuccess: (res) => {
                        //         const data = res.data;
                        //         id = (id || data.id);
                        //         navigate(`/car/${carId}`);
                        //     }
                        // })
                    }}
                >
                    {category !== "Sold" &&
                        <>
                            <div style={{ display: "flex", gap: "20px", marginBottom: "10px", alignItems: "center" }}>
                                {
                                    // [{ img: gear }, { img: mechanic }, { img: expense }]
                                    financeCategoryList
                                        // finances?.data
                                        ?.map(({ img: src, name }) => (
                                            <div>
                                                <AddButton active={name === category} onClick={() => {
                                                    setCategory(name)
                                                    // navigate(`/car/${id}/expense/new`)
                                                }}>
                                                    <div style={{ position: "relative" }}>
                                                        {/* <div style={{
                                                    position: "absolute",
                                                    top: "-3px", right: "-3px",
                                                    backgroundColor: "white",
                                                    border: "1px solid black",
                                                    width: "20px",
                                                    height: "20px",
                                                    borderRadius: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    // fontSize: "15px",
                                                    // lineHeight: "15px",
                                                    padding: "0px"

                                                }}>
                                                    +
                                                </div> */}
                                                        <img src={src} alt="" />
                                                    </div>
                                                    <div className='price'>
                                                        <Typography.Text>
                                                            {/* ${thousandSeparator(total?.[name] || 0)} */}
                                                            {name}
                                                        </Typography.Text>
                                                    </div>

                                                </AddButton>
                                            </div>
                                        ))
                                }
                            </div>

                            {(category === "Part" || category === "Other") &&
                                <Form.Item label=" " name={"type"}>
                                    <Radio.Group optionType='button' buttonStyle="solid" defaultValue={"expense"}>
                                        <Radio value={"expense"}>
                                            Buy
                                        </Radio>
                                        <Radio value={"income"}>
                                            Sell
                                        </Radio>
                                    </Radio.Group>
                                    {/* <InputNumber style={{ width: "100%" }} /> */}
                                </Form.Item>}
                        </>
                    }
                    <Form.Item label="Price" name={"price"}>
                        <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="AddedAt" name={"addedAt"}>
                        <DatePicker format="DD/MMM/YYYY" allowClear={false} defaultValue={dayjs()} style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="Note" name={"note"}>
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type='primary' block htmlType='submit'>
                            {

                                id ? "Update" : category === "Sold" ? "Mark as sold out" : "Save"}
                        </Button>
                    </Form.Item>
                </Form>
            </FormWrapper>
        </Wrapper>
    )
}

export default ExpenseForm